import React from "react";
import { List } from "episode/List";
import { AuthContext } from "auth";
import { fetchProgram } from "program";
import { useParams } from "react-router-dom";
import axios from "axios";

export function EpisodeList() {
  const { id } = useParams();
  const authContext = React.useContext(AuthContext);
  const [program, setProgram] = React.useState(null);
  const [episodeList, setEpisodeList] = React.useState([]);

  const fetchList = React.useCallback(async () => {
    try {
      const { data } = await fetchEpisodeList(id);
      const episodeList = data.map((d) => {
        d.program_episode_part.sort((p1, p2) => p1.part - p2.part);
        return d;
      });
      episodeList.sort((ep1, ep2) => ep1.episode - ep2.episode);
      setEpisodeList(episodeList);
    } catch (error) {
      console.error(error);
    }
  }, [id]);

  React.useEffect(() => {
    const f = async () => {
      const { data: program } = await fetchProgram(id);
      setProgram(program);
    };
    f();
  }, [id]);

  React.useEffect(() => {
    fetchList();
  }, [fetchList]);

  const onCreate = React.useCallback(
    async (values) => {
      try {
        await createEpisode(
          authContext.user,
          id,
          values,
          episodeList.length + 1
        );
        await fetchList();
      } catch (error) {
        console.error(error);
      }
    },
    [authContext.user, episodeList.length, fetchList, id]
  );

  const onDeleteEpisode = React.useCallback(
    async (episodeId) => {
      try {
        await deleteEpisode(id, episodeId);
        await fetchList();
      } catch (error) {
        console.error(error);
      }
    },
    [id, fetchList]
  );

  const onUpdateEpisode = React.useCallback(
    async (episodeId, values) => {
      try {
        await updateEpisode(authContext.user, id, episodeId, values);
        await fetchList();
      } catch (error) {
        console.error(error);
      }
    },
    [authContext.user, id, fetchList]
  );

  return (
    <List
      user={authContext.user}
      program={program}
      onCreateEpisode={onCreate}
      episodeList={episodeList}
      onDeleteEpisode={onDeleteEpisode}
      onUpdateEpisode={onUpdateEpisode}
    ></List>
  );
}

async function createEpisode(user, programId, data, episode) {
  return axios.request({
    url: `/program-api/program/${programId}/episode`,
    method: "POST",
    data: {
      ...data,
      episode,
      created_by: user.uid,
    },
  });
}

async function updateEpisode(user, programId, episodeId, data) {
  return axios.request({
    url: `/program-api/program/${programId}/episode/${episodeId}`,
    method: "PUT",
    data: {
      ...data,
      updated_by: user.uid,
    },
  });
}

async function fetchEpisodeList(programId) {
  return axios.request({
    url: `/r-api/program_episode?program=eq.${programId}&select=*,program_episode_part(*)`,
    method: "GET",
  });
}

async function deleteEpisode(programId, episodeId) {
  return axios.request({
    url: `/program-api/program/${programId}/episode/${episodeId}`,
    method: "DELETE",
  });
}
